import { PLAYER_JOINED, PLAYER_LEFT, CONNECTED_TO_PEERS, MESSAGE } from "../../actions/constants/actions.constants";
import { map } from 'rxjs/operators'

export default function connectToRoom (roomConnection) {
    return store => {
        if(!roomConnection){
            console.error("Room connection is expected, the API requires peer room concepts like joined, left, connected, and message");
        }

        roomConnection.GetIPFSNodeObservable().pipe(
            map(() => {
                roomConnection.ObservePeerJoinRequest()
                .subscribe(
                    (peer) => store.commit(PLAYER_JOINED, peer)
                );
        
                roomConnection.ObservePeerLeftEvent()
                .subscribe(
                    (peer) => store.commit(PLAYER_LEFT, peer)
                );
        
                roomConnection.ObserveRoomConnection()
                .subscribe(
                    (connected) => store.commit(CONNECTED_TO_PEERS, connected)
                );
        
                roomConnection.ObserveRoomEvents()
                .subscribe(
                    (peerEvent) => {
                        // more complex logic to ensure a user can not abuse the replay logic to expose the room prior to acceptance from peers.
                        switch(peerEvent) {
                            default:
                                store.commit(MESSAGE, peerEvent);
                                break;
                        }
                    }
                )        
            })
        );
        // when the store mutates the plugin may want to send out some events.
        store.subscribe(mutation => {
            switch(mutation){
                default:
                    roomConnection.SendEvent(mutation);
                    break;
            }
        });
    }
}
